<template>
  <!-- 资质查询 -->
  <div class="certExpired">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['客户管理', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <el-link
          @click="explain = true"
          style="margin-right: 10px"
          icon="el-icon-question"
          :underline="false"
          type="warning"
          >操作说明</el-link
        >
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.start"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择开始日期"
        >
        </el-date-picker>
        <el-date-picker
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          v-model="searchForm.end"
          clearable
          style="width: 200px; margin-right: 5px"
          placeholder="选择结束日期"
        >
        </el-date-picker>
        <el-input
          v-model="searchForm.name"
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="单位编号/单位名称/手机号"
        ></el-input>
        <el-button type="primary" @click="seach" icon="el-icon-search"
          >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="businesscode"
        show-overflow-tooltip
        label="客户编号"
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        align="center"
        show-overflow-tooltip
        label="客户名称"
      >
      </el-table-column>
      <el-table-column
        prop="clienttype"
        label="客户分类"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ypjyxkzxq"
        label="药品经营许可证"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="wtsxq"
        label="委托书有效期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="yyzzxq"
        label="营业执照有效期"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="yljgzyxkzxq"
        label="医疗机构职业许可证"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ndbgxq"
        label="年度报告"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="zlbzxyxq"
        label="质量保证协议"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="ylqxjyxkzxq"
        label="医疗器械经营许可证"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="UpdateTime"
        label="更新时间"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="gspxq"
        label="操作"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="primary"
            plain
            style="padding: 2px 3px"
            @click="seeInfo(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>

    <el-dialog
      title="操作说明"
      :visible.sync="explain"
      :close-on-click-modal="$store.state.closeOnClickModal"
      :close-on-press-escape="$store.state.closeOnPresEscape"
      width="70%"
    >
      <div class="explain-text">
        <p>查询用户资质</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "certExpired",
  data() {
    return {
      /*公司标识、公司编号、公司名称、价格优惠	经营许可	经营性质	
        地址	医疗器械	药品生产	医疗机构执业许可证	年度报告	
        质量保证协议	母婴保健	医疗器械生产	母婴保健技术	GSP证书	
        医疗器械生产	药品经营许可证	食品流通许可证	委托书*/
      /**表格数据 */
      tableData: [],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        name: "",
        start: "",
        end: "",
      },
      /**使用说明 */
      explain: false,
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    seach() {
      this.getTableData(1);
    },
    /**获取表格 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Pc_GetBusinessCode",
        clienttype: "clienttype",
        strWhere: this.searchForm.name,
        startTime: this.searchForm.start,
        endTime: this.searchForm.end,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "Pc_Credential"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "members/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    seeInfo(row) {
      let prams = encodeURIComponent(JSON.stringify({ id: row.userid }));
      let path = "certExpiredDetails";
      this.$router.push({
        path: path,
        query: {
          prams: prams,
        },
      });
    },
  },
};
</script>

<style scoped>
.certExpired {
  width: 100%;
  height: 100%;
}
</style>
